import React from "react";
import "./Modal.css";
import Me from "../../assets/me.jpeg";

function Modal({ send }) {
  return (
    <div className="box">
      <img className="profileImg" src={Me} alt="Me" />

      <div className="details">
        <div className="detail">
          <span>Age</span>
          <span>18</span>
        </div>
        <div className="detail">
          <span>Nationality</span>
          <span>Nigerian</span>
        </div>
        <div className="detail">
          <span>Yrs of Experience</span>
          <span>2yrs+</span>
        </div>
        <button className="contactMe" onClick={send}>
          Contact Me
        </button>
      </div>
    </div>
  );
}

export default Modal;
